export function getDurationInMinutes(startTime: number, endTime: number) {
    if (typeof startTime !== 'number' || typeof endTime !== 'number') {
        throw new Error('Both startTime and endTime must be numbers')
    }

    // Calculate duration in milliseconds
    const durationInMillis = endTime - startTime

    // Convert milliseconds to minutes
    const durationInMinutes = durationInMillis / (1000 * 60)

    return durationInMinutes
}
